// src/components/shared/InfoCard.js
import React from 'react';
import styled from 'styled-components';
import { DetailSection } from '../styled/DetailComponents';

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing(3)};
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(2)};
`;

const InfoCard = ({ title, icon, children, actions }) => {
  return (
    <DetailSection>
      <CardHeader>
        <h3>
          {icon}
          {title}
        </h3>
        {actions}
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
    </DetailSection>
  );
};

export default InfoCard;